import styles from './mobile-header.module.css';

import AnimatedHamburger from './animated-hamburger';
import ThemeSwitcher from './theme-switcher';
import { Box, Flex } from '@radix-ui/themes';
import StoreProvider from '../store-provider';
import LogoContainer from '../logo/logo-container';
import { LOGO_HEIGHT } from '@/app/lib/constants/sizes';

interface Props {
  isAtTop: boolean;
  isOpen: boolean;
  isClient: boolean;
}

export default function MobileHeader({ isAtTop, isOpen, isClient }: Props) {
  return (
    <div
      className={`${styles.Panel} ${
        isAtTop && !isOpen ? styles.Top : styles.Scrolled
      }`}
    >
      <Box width='200px'>
        <Flex
          justify='start'
          align='center'
          gap='4'
        >
          <AnimatedHamburger />
          <StoreProvider>
            <LogoContainer logoHeight={LOGO_HEIGHT.header} />
          </StoreProvider>
        </Flex>
      </Box>
      <Flex
        justify='end'
        align='center'
        gap='4'
      >
        {isClient && <ThemeSwitcher />}
      </Flex>
    </div>
  );
}
